import styled from 'styled-components';
import { OnlineThemeType } from '../../themes/online';
import { TooltipPosition } from './TooltipModels';

const positionTooltip = (position: TooltipPosition, tooltipHeight: number, arrow: boolean) => {
  switch (position) {
    case TooltipPosition.TopLeft:
      return `left:0;bottom:calc(${tooltipHeight}px + ${arrow ? '10px' : 0});`;
    case TooltipPosition.TopRight:
      return `right:0;bottom:calc(${tooltipHeight}px + ${arrow ? '10px' : 0});`;
    case TooltipPosition.BottomLeft:
      return `left:0;top:calc(${tooltipHeight}px + ${arrow ? '10px' : 0});`;
    case TooltipPosition.BottomRight:
      return `right:0;top:calc(${tooltipHeight}px + ${arrow ? '10px' : 0});`;
    case TooltipPosition.Center:
      return `right:50%;bottom:calc(100% + ${arrow ? '10px' : 0});transform:translate(50%);`;
  }
};
const positionArrow = (position: TooltipPosition, backgroundColor: string) => {
  switch (position) {
    case TooltipPosition.TopLeft:
      return `border-color:${backgroundColor} transparent transparent transparent; top: 100%; left: 20%;`;
    case TooltipPosition.TopRight:
      return `border-color:${backgroundColor} transparent transparent transparent; top: 100%; right: 20%;`;
    case TooltipPosition.Center:
      return `border-color:${backgroundColor} transparent transparent transparent; top: 100%; right: 50%; transform:translate(50%);`;
    case TooltipPosition.BottomLeft:
      return `border-color:transparent transparent ${backgroundColor} transparent; bottom: 100%; left: 20%;`;
    case TooltipPosition.BottomRight:
      return `border-color:transparent transparent ${backgroundColor} transparent; bottom: 100%; right: 20%;`;
  }
};
const printArrow = (arrow: boolean, position: TooltipPosition, backgroundColor: string, borderColor: string) => {
  if (arrow) {
    return `
    &:before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border-width: 11px;
      border-style: solid;
      ${positionArrow(position, borderColor)}
    }
    &:after {
      content: "";
      position: absolute;
      border-width: 10px;
      border-style: solid;
      ${positionArrow(position, backgroundColor)}
    }`;
  }

  return '';
};

const printToggler = (toggler: React.ReactNode, theme: OnlineThemeType) => {
  if (!toggler) {
    return `
      background-image: url(${theme.icons.questionMark});
      width: 13px;
      height: 14px;
    }`;
  }

  return '';
};

export const STooltipWrap = styled.section`
  display: inline-block;
  position: relative;
  vertical-align: middle;
`;

export const STooltipShow = styled.section<{ toggler: React.ReactNode }>(({ theme, toggler }) => {
  return `
  display: flex;
  align-items: center;
  cursor: pointer;

  ${printToggler(toggler, theme)};
`;
});

export const STooltip = styled.section<{
  position: TooltipPosition;
  width: string;
  arrow: boolean;
  height: string;
  maxWidth: string;
  minWidth: string;
  maxHeight: string;
  minHeight: string;
  backgroundColor: string;
  tooltipHeight: number;
  borderColor: string;
  contentColor: string;
  lineHeight: string;
  boxShadow: string;
}>(
  ({
    theme,
    position,
    width = 'inherit',
    height = 'inherit',
    maxWidth = 'inherit',
    minWidth = 'inherit',
    minHeight = 'inherit',
    maxHeight = 'inherit',
    backgroundColor,
    tooltipHeight,
    arrow,
    borderColor,
    boxShadow,
    contentColor,
    lineHeight = 'inherit',
  }) => {
    return `
  display: flex;
  position: absolute;
  ${positionTooltip(position, tooltipHeight, arrow)}
  background-color: ${backgroundColor};
  border-radius: ${theme.borderRadiusCommon}px;
  padding: ${theme.spacing.small}px ${theme.spacing.medium}px;
  height: ${height};
  width: ${width};
  max-width: ${maxWidth};
  min-width: ${minWidth};
  min-height: ${minHeight};
  max-height: ${maxHeight};
  color: ${contentColor || theme.colors.black};
  text-align: left;
  font-size: ${theme.font.size.small};
  z-index: 1;
  border: 1px solid ${borderColor};
  line-height: ${lineHeight};
  box-shadow: ${boxShadow};
  ${printArrow(arrow, position, backgroundColor, borderColor)};
`;
  }
);
